import { orderDetailsButtonSetStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsButtonSet";
import { css } from "styled-components";

Object.assign(orderDetailsButtonSetStyles, {
    shareEntityButtonStyles: {
        button: {
            css: css`
                display: none;
            `,
        },
        clickable: {
            css: css`
                display: none !important;
            `,
        },
    },
    reorderButton: {
        variant: "primary",
    },
});
